import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["step"]

import {computed, inject, onMounted, ref} from 'vue';
    import {useTranslation} from '@malt/vue3-use';
    import {ApplicationStatus, VettingDelay} from '@/profile-creation-wizard/types';
    import ApplicationSubmitted from '@/profile-creation-wizard/components/waiting-room/application-statuses/ApplicationSubmitted.vue';
    import ApplicationAccepted from '@/profile-creation-wizard/components/waiting-room/application-statuses/ApplicationAccepted.vue';
    import ApplicationRefused from '@/profile-creation-wizard/components/waiting-room/application-statuses/ApplicationRefused.vue';
    import Error from '@/profile-creation-wizard/components/waiting-room/application-statuses/Error.vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'WaitingRoom',
  setup(__props) {

    const applicationStateRepository = inject(DI.applicationStateRepository)!;

    const {msg} = useTranslation();
    const applicationStatus = ref<ApplicationStatus>();
    const isError = ref<boolean>(false);
    const hasVettingDelay = ref<boolean>(false);

    onMounted(async () => {
        try {
            applicationStatus.value = await applicationStateRepository.getApplicationState();
            if (applicationStatus.value === ApplicationStatus.SUBMITTED) {
                const delay = await applicationStateRepository.vettingDelay();
                hasVettingDelay.value = delay === VettingDelay.HIGH;
            }
        } catch {
            isError.value = true;
            pushVJoySnackbar({
                props: {
                    message: msg('generic.technical.error'),
                    level: 'error',
                },
            });
        }
    });

    const componentFromStatus = computed(() => {
        if (isError.value) {
            return Error;
        }
        switch (applicationStatus.value) {
            case ApplicationStatus.ACCEPTED:
                return ApplicationAccepted;
            case ApplicationStatus.REFUSED:
                return ApplicationRefused;
            case ApplicationStatus.SUBMITTED:
                return ApplicationSubmitted;
            default:
                return null;
        }
    });

    const stepCount = computed(() => {
        if (!applicationStatus.value) {
            return 2;
        }
        return applicationStatus.value === ApplicationStatus.SUBMITTED ? 2 : 4;
    });

return (_ctx: any,_cache: any) => {
  const _component_VJoyHighlight = _resolveComponent("VJoyHighlight")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("joy-stepper", { step: stepCount.value }, [
      _createElementVNode("joy-step", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.waiting.room.stepper.step1')), 1),
      _createElementVNode("joy-step", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.waiting.room.stepper.step2')), 1),
      _createElementVNode("joy-step", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.waiting.room.stepper.step3')), 1)
    ], 8, _hoisted_1),
    _createVNode(_component_VJoyWrapper, {
      class: "application-status-container",
      justify: "center",
      align: "center",
      noMargin: "",
      direction: "column"
    }, {
      default: _withCtx(() => [
        (hasVettingDelay.value)
          ? (_openBlock(), _createBlock(_component_VJoyHighlight, {
              key: 0,
              class: "review-delays-highlighter",
              "data-testid": "waiting-room-review-delays",
              "display-icon": true,
              icon: "clock",
              level: "warning",
              accent: "true"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.wizard.strategy.waiting.room.application.review.delay')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_resolveDynamicComponent(componentFromStatus.value)))
      ]),
      _: 1
    })
  ], 64))
}
}

})